import React, { useState } from "react";
import AgentIdDetails from "./AgentComponent/AgentIdDetails";
import AgentPersonalDetails from "./AgentComponent/AgentPersonalDetails";
import PayoutStructure from "./AgentComponent/PayoutStructure";
import backArrow from '../../asset/images/IBA/backArrow.svg';
import IBAAgentModalCommon from "../IBAAgentModalCommon";

function AgentDetailsCardChild({ agent, setViewDetails }) {
    const [modalHide, setModalHide] = useState(false);
    const [editType, setEditType] = useState(""); // "personal", "bank", or "profile"
    const [editData, setEditData] = useState({});
    const personal = {
        fullName: "Pranay Panigrahi",
        dob: "21-09-2002",
        gender: "Male",
        address: "123 Abc Society, Malkhapur, Sector 12, Lucknow, Uttar Pradesh-123456",
        aadhaar: "1234 1234 1234",
        pan: "ABCDE1232A"
    };
    const bankDetails = {
        accountNumber: "12345678901234",
        ifscCode: "ICICI00000001",
        micr: "878682800001",
        branchName: "ICICI Viman Nagar Branch",
        branchAddress: "123 Abc Society, Malkhapur, Sector 12, Lucknow, Uttar Pradesh-123456"
    };
    const handleEditClick = (type, data) => {
        setEditType(type);
        setEditData(data);
        setModalHide(true);
    };
    return (
        <>
            <div className="card-title agent-card">
                <img src={backArrow} alt="backArrow" height="18px" width="18px" onClick={() => setViewDetails(true)} />
                <h2 className="h2-css-all">Agent Details</h2>
            </div>
            <div className="card-contnent">
                <AgentIdDetails  onEditClick={handleEditClick} />
                <div className="performer-box">
                    <AgentPersonalDetails type="personal" data={personal} onEditClick={handleEditClick} />
                    <AgentPersonalDetails type="bank" data={bankDetails} onEditClick={handleEditClick} />
                </div>
                <div className="payout">
                    <PayoutStructure />
                </div>
            </div>
            {modalHide && (
                <IBAAgentModalCommon
                    modalHide={modalHide}
                    setModalHide={setModalHide}
                    editType={editType}
                    editData={editData}
                />
            )}
        </>
    );
}

export default AgentDetailsCardChild;
